export default __webpack_public_path__ + "static/marvin-393df085f0f36a8dbb46b94f88206d14.png";